export default "__VITE_ASSET__f302d317__"